// extracted by mini-css-extract-plugin
export default {"commentBox":"Comment_commentBox__GDU6M","commentList":"Comment_commentList__sk1dv"};